module.exports = __webpack_public_path__ + "img/neck_width.603de404.png";